module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }